<template>
	<router-link
		tag="a"
		:to="`/tienda/producto/${item.slug}`"
		class="item"
		:class="{ 'item-horizontal': display == 'horizontal' }"
	>
		<div class="image" v-if="item.image" :style="'background-image:url(' + item.image.url + ')'"></div>
		<div class="image no-image" v-else ></div>

		<div class="data">
			<div class="data-content">
				<h2 class="title">{{ item.name }}</h2>
				<div>
					<div class="data-item" v-if="item.dimensions">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-dimensions"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path d="M3 5h11"></path>
							<path d="M12 7l2 -2l-2 -2"></path>
							<path d="M5 3l-2 2l2 2"></path>
							<path d="M19 10v11"></path>
							<path d="M17 19l2 2l2 -2"></path>
							<path d="M21 12l-2 -2l-2 2"></path>
							<rect x="3" y="10" width="11" height="11" rx="2"></rect>
						</svg>
						{{ item.dimensions }}
					</div>
					<div class="data-item" v-if="item.capacity">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-users"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<circle cx="9" cy="7" r="4"></circle>
							<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
							<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
							<path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
						</svg>
						{{ item.capacity }}
					</div>
					<div class="data-item" v-if="item.waterTank">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-droplet"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path d="M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"></path>
						</svg>
						{{ item.waterTank }}
					</div>
				</div>
				<div class="price mt-2" v-if="item.priceWithoutTaxes>0" >
					<span class="currency mr-1">U$S</span>
					<span class="amount">{{ item.priceWithoutTaxes.toFixed(2) }}</span>
					<small class="ml-1">+ IVA</small>
				</div>
				<div class="mb-2" v-if="item.featured" v-html="item.featuredDetail"></div>
			</div>
			<button class="btn btn-block btn-primary">
				Más información
			</button>
		</div>
	</router-link>
</template>
<script>
export default {
	name:"TiendaListItem",
	props: ["item", "display"]
}
</script>

<style scoped>
.item {
	display: flex;
	flex-direction: column;
	position: relative;
	margin: 4px;
	padding: 0;
	text-align: center;
	color: #000;
	transition: all 0.4s ease-in-out;
	background-color: #fff;
	border-radius: 10px;
	overflow: hidden;
	
}

.item:hover {
	box-shadow: 0px 4px 10px #0000001a;
}

.item .title {
	font-weight: 400;
    font-size: 1rem;
    line-height: 1.1;
    z-index: 10;
	text-align: center;
    
}
.item .image {
	width: 100%;
	aspect-ratio: 16 / 12;
	background-color: #fff;
	margin: 8px auto 0px auto;
	background-size: contain;
	background-position: center center;
	background-repeat: no-repeat;
}
.item .data {
	position: relative;
	flex-grow: 1;
	aspect-ratio: 16 / 14;
	padding: 18px 12px;
	text-align: left;
	display: flex;
    flex-direction: column;
}
.item .data .data-content {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.item .data .data-item {
	display: flex;
	padding: 8px;
	align-items: center;
	font-size: 13px;
}
.item .data .data-item svg {
	width: 18px;
	margin-right: 8px;
}

.item .data .btn {
	margin: auto;
	background: #d4d4d4;
    border-color: #d4d4d4;
	color: #303030;
	font-size: 12px;
	opacity: 0;
}
.item:hover .data .btn {
	background: #3a78c9 !important;
    border-color: #3a78c9 !important;
	color: #ffffff;
	opacity: 1;
}

.item .price {
	font-size: 14px;
	text-align: center;
	line-height: 20px;
}
.item .price .currency {
	font-size: 11px;
	font-weight: 500;
}
.item .price .amount {
	font-size: 16px;
	font-weight: 600;
}

.badge-primary {
	width: 90px;
	background-color: var(--primary-color);
	border-radius: 20px;
	font-size: 10px;
	font-weight: 500;
	padding: 6px;
	position: absolute;
	top: -20px;
	left: calc(50% - 45px);
}

.item.item-horizontal {
	flex-direction: row;
	align-items: center;
}
.item.item-horizontal .image {
	padding-bottom: 30%;
}
.item.item-horizontal .data {
	text-align: left;
}
.item.item-horizontal .data .btn {
	margin: inherit;
}
</style>
